import { HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { GeneralResult } from '@domain/entities/general';
import { InventoryModel } from '@domain/entities/inventory';
import { InventoryServerModel } from '@domain/entities/inventory';

export abstract class InventoryGateway {
    abstract read(
        params?: HttpParams
    ): Observable<GeneralResult<InventoryServerModel>>;
    abstract create(form: InventoryModel): Observable<InventoryServerModel>;
    abstract readById(id: number): Observable<InventoryServerModel>;
    abstract update(
        id: number,
        form: InventoryModel
    ): Observable<InventoryServerModel>;
    abstract delete(id: number): Observable<InventoryServerModel>;
    abstract upload(file: FormData): Observable<{ src: string }>;
}
